module.exports = __webpack_public_path__ + "img/1700186412811-WhatsApp Image 2023-11-17 at 09.58.24.jpeg.656fa070.webp";